module.exports = __webpack_public_path__ + "static/media/c4d81d4ae0e00b3b4a2dc416680ece9a.79503643.mp4";